// import listing path
import Login from "../view/Login";
import Products from "../view/master/Products";
import Customers from "../view/Customers";
import Invoice from "../view/Invoice";
import BalanceSheet from "../view/BalanceSheet";
import BalanceSheetCreations from "../view/creations/BalanceSheetCreations";
import Unit from "../view/master/Unit";
import Category from "../view/master/Category";
import Agent from "../view/master/Agent";
import AgentCreations from "../view/creations/AgentCreation";
import AgentInvoices from "../view/AgentInvoices";
import AgentBalanceSheet from "../view/AgentBalanceSheet";
// pdf
import Billpreview from "../pdf/BillPreview";
import InvoiceCreations from "../view/creations/InvoiceCreations";
import DailyLogins from "../view/Company";
import CustomersCreations from "../view/creations/CustomersCreations";
import User from "../view/master/User";
import BillsPreview from "../pdf/BillsPreview";
import OverallReports from "../view/OverallReports";
import DetailedReport from "../view/DetailedReport";
const routes = [
  // login route
  { path: "/", element: <Login /> },
  // Page Routes litsing
  { path: "/company", element: <DailyLogins /> },
  { path: "/master/unit", element: <Unit /> },
  { path: "/master/category", element: <Category /> },
  { path: "/master/user", element: <User /> },
  { path: "/master/products", element: <Products /> },
  { path: "/master/agent", element: <Agent /> },
  { path: "/products", element: <Products /> },
  { path: "/customers", element: <Customers /> },
  { path: "/balance-sheet", element: <BalanceSheet /> },
  { path: "/invoices", element: <Invoice /> },
  { path: "/agent-invoices/:agentName", element: <AgentInvoices /> },
  { path: "/agent-balance-sheet/:agentName", element: <AgentBalanceSheet /> },
  { path: "/billpreview", element: <Billpreview /> },
  { path: "/billpreviews", element: <BillsPreview /> },
  { path: "/reports", element: <OverallReports /> },
  { path: "/reports/detailed-report", element: <DetailedReport /> },
  // page routes creations
  { path: "/create-invoice", element: <InvoiceCreations /> },
  { path: "/create-customer", element: <CustomersCreations /> },
  { path: "/create-balance-sheet", element: <BalanceSheetCreations /> },
  { path: "/create-agent", element: <AgentCreations /> },
];
export default routes;
